import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { BusinessReportItem } from 'src/modules/serasa/serasa.experian.business.types'

export type ContatosProps = {
    empresa: BusinessReportItem
}

export default function Contatos({ empresa }: ContatosProps) {
    return (
        <>
            <Divider textAlign="center">Contatos</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem
                    label="Telefone"
                    value={
                        !empresa.identificationReport.phone
                            ? '-'
                            : `(${empresa.identificationReport.phone.areaCode}) ${empresa.identificationReport.phone.phoneNumber}`
                    }
                    xs={6}
                />
                <GridItem label="Home Page" value={empresa.identificationReport.companyUrl || '-'} xs={12} />
            </Grid>
        </>
    )
}
